"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuableItem = void 0;
class ValuableItem {
}
exports.ValuableItem = ValuableItem;
//# sourceMappingURL=ValuableItem.js.map